import { t } from 'i18next';
import * as Yup from 'yup';

export const addNoticePeriodAutomation = Yup.object({
  name: Yup.string().required(t('required-field')),
  days: Yup.number().required(t('required-field')),
});

